export default __webpack_public_path__ + "static/error_status-da6a8940e0e753b82b7468b614a61c86.gif";